import { computed, inject, Injectable, signal, Signal, WritableSignal } from '@angular/core';
import { MenuItem } from '../menu-item';

@Injectable({providedIn: 'root'})
export class MenuItemService {

  private _menuItems: WritableSignal<Signal<MenuItem[]>[]> = signal([]);

  readonly menuItems = computed(() => {
    return this._menuItems().reduce((acc, menuItems) => [...acc, ...menuItems()], [] as MenuItem[]);
  });

  readonly outlet = (name: string) => computed(() => {
    const menuItems = this.menuItems();
    return menuItems.filter(item => item.outlet === name)
      .sort((a, b) => (b.priority ?? 0) - (a.priority ?? 0));
  });

  add(menuItems: Signal<MenuItem[]>): void {
    this._menuItems.set([...this._menuItems(), menuItems]);
  }

  remove(menuItems: Signal<MenuItem[]>): void {
    this._menuItems.set(this._menuItems().filter(item => item !== menuItems));
  }
}
